import api from './api';

export function getAdvisor(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}`)
}


export function getContratoAsesor(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/contrato-asesor/${idAdvisor}`)
}